const doc = [({"da":({"js":({"forms":({"attachment_input":({"the_file_was_deleted":"Filen blev slettet"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;